import { writable } from "svelte/store";

const Scene = writable(null)
const Renderer = writable(null)
const SceneControls = writable(null)
const Camera = writable(null)

export {
    Scene, Renderer, SceneControls, Camera
}
